<template>
    <div class="chart" id="assetChart" ></div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex';
import { get } from '@/api/index';
import { getAssetChartDatas } from "@/api/api";

export default {
    data() {
        return {
            chartData: {},
            myChart: null,
            show_data_rate: {},
            show_data: {}
        }
    },
    mounted() {
        this.getAssetRateData('u');
    },
    props: ['currencyFlag'],
    computed: {
        ...mapState([
            'id',
            'token',
            'layout',
            'currencyChangeFlag'
        ])
    },
    methods: {
        // 获取资产比率快照图数据
        getAssetRateData(flag) {
            var param = {
                'token': this.token,
                'apiId': this.id.apiId,
                'layout': this.layout
            };
            var chart_node = document.getElementById('assetChart');
            this.myChart = this.$echarts.init(document.getElementById('assetChart'));
            this.myChart.clear();
            this.myChart.showLoading({
                text: 'loading',
                color: '#c23531',
                textColor: '#000',
                maskColor: '#262829',
                zlevel: 0
            })
            // get(url, param).then(resp => {
            //     if (resp.code == 200) {
            //         this.chartData = resp.data;
            //         console.log('flag', this.currencyChangeFlag);
            //         this.show_data_change(this.currencyChangeFlag);
            //         this.paintChart();
            //     } else {
            //         this.$notify.error({
            //             message: resp.info,
            //             title: '提示',
            //             offset: 100
            //         })
            //     }
            // });

            getAssetChartDatas(param).then(resp => {
                if (resp.code == 200) {
                    this.chartData = resp.data;
                    this.show_data_change(this.currencyChangeFlag);
                    this.paintChart();
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        show_data_change(flag) {
            if (flag == 'u') {
                this.show_data = this.chartData.equity_usdt
                this.show_data_rate = this.chartData.equity_rate_usdt
            } else {
                this.show_data = this.chartData.equity
                this.show_data_rate = this.chartData.equity_rate
            }

            if (this.myChart) {
                this.myChart.clear();
            }
            this.paintChart()
        },

        // 绘制图表
        paintChart() {
            // var myChart = this.$echarts.init(document.getElementById('assetChart'));
            var showData = this.show_data;
            this.myChart.hideLoading();
            var option = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    formatter: function (param) {
                        var showHtml = '' + param[0].axisValue + '<br>';
                        for (var i=0; i<param.length; i++) {
                            var paramObj = param[i];
                            var currency_name = paramObj.seriesName;
                            var value = paramObj.value;
                            var currency_num = showData[currency_name][paramObj.dataIndex];
                            showHtml += paramObj.marker +  currency_name + ': '+ currency_num + '<br>'; 
                        }
                        return showHtml;
                    }
                },
                legend: {
                    data: ['BCH', 'BSV', 'BTC', 'EOS', 'ETC', 'ETH', 'LTC', 'USDT', 'XRP', 'TRX', 'total_value'],
                    textStyle: {
                        color: '#969292'
                    }
                },
                grid: {
                    left: '3%'
                },
                calculable : true,
                dataZoom: [{
                    show: true,
                    realtime: true,
                    start: 30,
                    end: 100
                },
                {
                    type: 'inside',
                    start: 30,
                    end: 100,
                    height: 20
                }],
                xAxis: [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : this.chartData.dateTime,
                        axisLabel: {
                            textStyle: {
                                fontSize: 10,
                                color: '#969292'
                            },
                        },
                        axisTick: {
                            show: false,
                            interval: 2,
                            length: 10,
                            color: '#969292'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#969292'
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type : 'value',
                        position: 'right',
                        axisLabel : {
                            formatter: '{value} %',
                            color: '#969292'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#969292',
                            }
                        },
                        splitNumber: 10,
                        splitLine: {
                            show: false
                        }
                    }
                ],
                series: [
                    {
                        name:'BTC',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.BTC,
                    },
                    {
                        name:'EOS',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 2,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.EOS,
                    },
                    {
                        name:'USDT',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.USDT,
                    },
                    {
                        name:'BCH',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.BCH,
                    },
                    {
                        name:'BSV',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.BSV,
                    },
                    {
                        name:'ETC',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,                     
                        smooth: true,
                        data: this.show_data_rate.ETC,
                        emphasis: {
                            lineStyle: {
                                width: 4
                            }
                        }
                    },
                    {
                        name:'ETH',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.ETH,

                    },
                    {
                        name:'XRP',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,

                        smooth: true,
                        data: this.show_data_rate.XRP,
                    },
                    {
                        name:'LTC',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        smooth: true,
                        data: this.show_data_rate.LTC,
                    },
                    {
                        name:'TRX',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.TRX,
                    },
                    {
                        name:'total_value',
                        type:'line',
                        symbol: 'circle',
                        symbolSize: 1,
                        showSymbol: false,
                        smooth: true,
                        data: this.show_data_rate.total_value,
                    },
                ]
            };

            this.myChart.setOption(option);
            var that = this;
            // 自适应
            window.onresize = function() {
                if ($('.el-dialog').parent().width() < 680) {
                    document.getElementById('assetChart').style.width = 350 + 'px';
                } else {
                    document.getElementById('assetChart').style.width = $('.el-dialog').parent().width()/2 + 'px';
                }
                if (typeof that.myChart !== 'undefined') {
                    that.myChart.resize();
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .chart{
        height: 400px;
        width: 100%;
        margin: 0 auto;
    }
</style>
